import { useState } from 'react';
import { getPlatformName } from '../../utils/mobileDownloadConfig';

/**
 * Device platform selector dropdown component
 * Reusable for all mobile download partners (T-Mobile, Metro, etc.)
 */
export default function DevicePlatformSelector({
  selectedPlatform,
  onPlatformChange,
  detectedPlatform,
  supportedPlatforms,
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const currentPlatform = selectedPlatform || detectedPlatform;

  const handlePlatformSelect = (platformId) => {
    onPlatformChange(platformId);
    setShowDropdown(false);
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <label htmlFor="platform-select" style={{ display: 'block', marginBottom: '12px', fontSize: '14px' }}>
        Select Your Device:
      </label>

      <button
        id="platform-select"
        onClick={() => setShowDropdown(!showDropdown)}
        aria-expanded={showDropdown}
        aria-controls="platform-options"
        style={{
          width: "100%",
          padding: "12px 15px",
          border: "1px solid #ccc",
          borderRadius: "2px",
          backgroundColor: "#fff",
          color: "#333",
          fontSize: "14px",
          cursor: "pointer",
          textAlign: "left",
          fontWeight: "normal",
        }}
        aria-label="Select your device platform"
      >
        {currentPlatform ? getPlatformName(currentPlatform) : "Choose a platform"}
        {" "}
        <span style={{ float: "right" }}>▼</span>
      </button>

      {showDropdown && (
        <div
          id="platform-options"
          role="listbox"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderTop: "none",
            borderRadius: "0 0 2px 2px",
            zIndex: 10,
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            marginTop: "-1px",
          }}
        >
          {supportedPlatforms.map((platformId) => (
            <button
              key={platformId}
              role="option"
              aria-selected={currentPlatform === platformId}
              onClick={() => handlePlatformSelect(platformId)}
              style={{
                width: "100%",
                padding: "12px 15px",
                border: "none",
                backgroundColor: currentPlatform === platformId ? "#f5f5f5" : "#fff",
                color: "#333",
                fontSize: "14px",
                cursor: "pointer",
                textAlign: "left",
                borderBottom: "1px solid #e5e5e5",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f5f5f5")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = currentPlatform === platformId ? "#f5f5f5" : "#fff")}
            >
              {getPlatformName(platformId)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
